import React from 'react';
import {useSelector} from 'react-redux';

import {useGetUserSearchResultLimits} from '../../hooks/useGetUserSearchResultLimits';
import {userSearchResultResultSelector} from '../../slices/user-search-result.slice';

import {HeaderCaption} from './header-caption';
import {HeaderSkeleton} from './header-skeleton';

type Props = {
    userIds: number[],
    totalCount: number,
    columnId: string,
};

const LimitHeaderController = ({userIds, totalCount, columnId}: Props) => {
    const {isLoading, loadingError} = useGetUserSearchResultLimits({
        userIds,
        totalCount,
        columnId,
    });

    return (
        <HeaderCaption
            isLoading={isLoading}
            loadingError={loadingError}
            columnId={columnId}
        />
    );
};

export const LimitHeader = ({columnId}: {columnId: string}) => {
    const result = useSelector(userSearchResultResultSelector);

    return result ? (
        <LimitHeaderController
            userIds={result.data.map(({id}) => id)}
            totalCount={result.totalCount}
            columnId={columnId}
        />
    ) : (
        <HeaderSkeleton columnId={columnId}/>
    );
};
